import React, { useState, useEffect } from "react";
import {BrowserRouter, Routes, Route, Link } from "react-router-dom";
//import './App.css';
import './styles/other.css';

//utilities
import { showMobileVersion } from './utilities/OtherUtilities.js';

//components
import TopMenu from "./menus/TopMenu.js";
import LeftMenu from "./menus/LeftMenu.js";
import LeftMenuClosed from "./menus/LeftMenuClosed.js";
import AlertModalMessage from './modals/AlertModalMessage.js';
import AlertModalMessageTwoButton from './modals/AlertModalMessageTwoButton.js';
import AlertModalMessageMobile from './modals_m/AlertModalMessageMobile.js';
import AlertModalMessageTwoButtonMobile from './modals_m/AlertModalMessageTwoButtonMobile.js';

//pages
import TestingPage from "./pages/TestingPage.js";
import Login from "./pages/Login.js";
import ListTasks from "./pages/ListTasks.js";
import ListProjects from "./pages/ListProjects.js";
import ListApplications from "./pages/ListApplications.js";
import ListFundings from "./pages/ListFundings.js";
import ListGrants from "./pages/ListGrants.js";
import ListSubmissions from "./pages/ListSubmissions.js";
import ListFinWorkflow from "./pages/ListFinWorkflow.js";
import ListProjWorkflow from "./pages/ListProjWorkflow.js";
import NewSubmission from "./pages/NewSubmission.js";
import SubmissionDetail from "./pages/SubmissionDetail.js";
import FundingDetail from "./pages/FundingDetail.js";
import ApplicationDetail from "./pages/ApplicationDetail.js";
import TaskDetail from "./pages/TaskDetail.js";
import ProjectDetail from "./pages/ProjectDetail.js";
import Rights from "./pages/Rights.js";
import RecoverPasswordPage from "./pages/RecoverPasswordPage.js";
import NotFoundPage from "./pages/NotFoundPage.js";
import FinDashboard from "./pages/FinDashboard.js";
import FinReports from "./pages/FinReports.js";

function setToken(userToken) {
    localStorage.setItem('token', JSON.stringify(userToken));
};

function getToken() {
    try {
        const tokenString = localStorage.getItem('token');
        const userToken = JSON.parse(tokenString);
        return userToken?.token
        // return tokenString;
        console.log(userToken);
    }
    catch(err){
        return null;
    }
};

class App extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            actualSection: "none", // for leftMenu to activate buttons (people, churches, conversations, events)
            leftMenuOpened: "true",
            searchText: "",
            allOrMy: localStorage.getItem("allOrMy") || "my",
            allOrMyMinistry: localStorage.getItem("allOrMyMinistry") || "all",
            topMenuExpanded: false, // default is: false
            prepareToShowAlertModalMessage: false,
            showAlertModalMessage: false,
            prepareToShowAlertModalMessageTwoButton: false,
            showAlertModalMessageTwoButton: false,
            prepareToShowAlertModalMessageMobile: false,
            showAlertModalMessageMobile: false,
            prepareToShowAlertModalMessageTwoButtonMobile: false,
            showAlertModalMessageTwoButtonMobile: false,
            alertMessage: "Message",
            alertCloseButton: "OK",
            alertActionButton: "OK",
            alertOnAction: {},
        };
    }


    componentDidMount(){
        this.setState({ actualSection: localStorage.getItem("actualSection") || "none" });
        this.setState({ searchText: localStorage.getItem("searchText") || "" });
        if(localStorage.getItem("leftMenuOpened")){
            this.setState({ leftMenuOpened: localStorage.getItem("leftMenuOpened") });
        }
        else {
            if(window.innerWidth <= 1200){
                this.setState({ leftMenuOpened: "false" });
            }
            else{
                this.setState({ leftMenuOpened: "true" });
            }
        }

        // on every click, gesture or resizing the resizing method is called to adjust the height of the website
        window.addEventListener('resize', this.documentHeight(0));
        window.addEventListener('mouseup', this.documentHeight(500));
        window.addEventListener('touchend', this.documentHeight(500));
        // listener for orientation change on mobile devices
        //window.addEventListener('orientationchange', () => this.documentHeight(0), false); // this one is deprecated
        window.screen.orientation.addEventListener("change", (event) => {
            //const type = event.target.type;
            //const angle = event.target.angle;
            //console.log(`ScreenOrientation change: ${type}, ${angle} degrees.`);
            this.documentHeight(0);
        });
        this.documentHeight(0);

    }

    documentHeight = async (time) => {
        // for some gesture it is better to wait some time before making resizing method
        await new Promise(resolve => setTimeout(resolve, time));

        //const doc = document.documentElement;
        //doc.style.setProperty('--doc-height', window.innerHeight+"px");

        // getting value that will be used as height size
        const heights = [window.innerHeight];
        if(window.screen?.height)heights.push(window.screen?.height);
        const height = Math.min(...heights);
        const doc = document.documentElement;

        // if user zoomed on the website then do not change the height using javascript and set it to 100vh
        if(window.visualViewport.scale > 0.8 && window.visualViewport.scale < 1.2){
            doc.style.setProperty('--doc-height', height+"px");
        }
        else {
            doc.style.setProperty('--doc-height', "100vh");
        }

    }

    setActualSection = (newActualSection) => {
        if(newActualSection != "advancedSearch" && newActualSection != "quickSearch"){ this.setSearchText(""); }
        this.setTopMenuExpanded(false);

        this.setState({ actualSection: newActualSection });
        localStorage.setItem("actualSection", newActualSection);
    }

    setLeftMenuOpened = (isOpened) => {
        this.setState({ leftMenuOpened: isOpened });
        localStorage.setItem("leftMenuOpened", isOpened);
    }

    logoutUser = () => {
        setToken(null);
        window.location.reload();
    }

    setSearchText = (textToSearch) => {
        this.setState({ searchText: textToSearch });
        localStorage.setItem("searchText", textToSearch);
    }

    setAllOrMy = (newValue) => {
        if(newValue == "all"){
            localStorage.setItem("allOrMy", "all");
            this.setState({ allOrMy: "all" });
        }else {
            localStorage.setItem("allOrMy", "my");
            this.setState({ allOrMy: "my" });
        }
    }

    setAllOrMyMinistry = (newValue) => {
        if(newValue == "all"){
            localStorage.setItem("allOrMyMinistry", "all");
            this.setState({ allOrMyMinistry: "all" });
        }else {
            localStorage.setItem("allOrMyMinistry", "my");
            this.setState({ allOrMyMinistry: "my" });
        }
    }

    setTopMenuExpanded = (value) => {
        this.setState({ topMenuExpanded: value });
    }

    openAlertMessage = async (message, closeButton) => {
        await this.setState({ alertMessage: message });
        await this.setState({ alertCloseButton: closeButton });

        // show mobile alertMessage or PC alertMessage
        if(showMobileVersion()){
            await this.setState({ prepareToShowAlertModalMessageMobile: true });
            this.setState({ showAlertModalMessageMobile: true });
        }
        else {
            await this.setState({ prepareToShowAlertModalMessage: true });
            this.setState({ showAlertModalMessage: true });
        }
    }

    openAlertMessageTwoActions = async (message, closeButton, actionButton, onAction) => {
        if((actionButton == null || actionButton == "") && onAction == null){
            this.openAlertMessage(message,closeButton);
        }
        else {
            await this.setState({ alertMessage: message });
            await this.setState({ alertCloseButton: closeButton });
            await this.setState({ alertActionButton: actionButton });
            await this.setState({ alertOnAction: onAction });

            // show mobile alertMessage or PC alertMessage
            if(showMobileVersion()){
                await this.setState({ prepareToShowAlertModalMessageTwoButtonMobile: true });
                this.setState({ showAlertModalMessageTwoButtonMobile: true });
            }
            else {
                await this.setState({ prepareToShowAlertModalMessageTwoButton: true });
                this.setState({ showAlertModalMessageTwoButton: true });
            }
        }
    }

    closeAlertMessage = async () => {
        this.setState({ showAlertModalMessage: false });
        this.setState({ showAlertModalMessageTwoButton: false });
        await new Promise(resolve => setTimeout(resolve, 1000));
        await this.setState({ prepareToShowAlertModalMessage: false });
        await this.setState({ prepareToShowAlertModalMessageTwoButton: false });
    }

    closeAlertModalMessageMobile = async () => {
        this.setState({ showAlertModalMessageMobile: false });
        await new Promise(resolve => setTimeout(resolve, 1000));
        await this.setState({ prepareToShowAlertModalMessageMobile: false });
    }

    closeAlertModalMessageTwoButtonMobile = async () => {
        this.setState({ showAlertModalMessageTwoButtonMobile: false });
        await new Promise(resolve => setTimeout(resolve, 1000));
        await this.setState({ prepareToShowAlertModalMessageTwoButtonMobile: false });
    }

    render() {
        const token = getToken();
        if(window.location.pathname == "/password/reset") {
            //if(showMobileVersion()){
            //    return <RecoverPasswordPageMobile />
            //}
            //else {
                return <RecoverPasswordPage />
            //}
        }
        if(!token) { return <Login setToken={setToken} /> }
        console.log(token);

        return (
            <BrowserRouter>
                <div className="horizontalStack" style={{height: "100%", height: "var(--doc-height)", minHeight: "100vh", minHeight: "var(--doc-height)", backgroundColor: "var(--full-black)"}}>

                    {/* LEFT MENU */}
                    {/* this web does not have mobile version yet, so I added 1==2 to never show mobile version */}
                    {showMobileVersion() && 1 == 2  ?
                        <div>
                            {this.state.leftMenuOpened == "true" ? {/*<LeftMenuMobile actualSection={this.state.actualSection} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} setLeftMenuOpened={this.setLeftMenuOpened} allOrMy={this.state.allOrMy} setAllOrMy={this.setAllOrMy} allOrMyMinistry={this.state.allOrMyMinistry} setAllOrMyMinistry={this.setAllOrMyMinistry} />*/}
                            : {/*<LeftMenuClosedMobile actualSection={this.state.actualSection} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} setLeftMenuOpened={this.setLeftMenuOpened} />*/} }
                        </div>
                    :   <div>
                            {this.state.leftMenuOpened == "true" ? <LeftMenu actualSection={this.state.actualSection} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} setLeftMenuOpened={this.setLeftMenuOpened} allOrMy={this.state.allOrMy} setAllOrMy={this.setAllOrMy} allOrMyMinistry={this.state.allOrMyMinistry} setAllOrMyMinistry={this.setAllOrMyMinistry} />
                            : <LeftMenuClosed actualSection={this.state.actualSection} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} setLeftMenuOpened={this.setLeftMenuOpened} /> }
                        </div>}

                    <div className="flex" style={{height: "100%", height: "var(--doc-height)", minHeight: "100vh", minHeight: "var(--doc-height)", backgroundColor: "var(--lightest-gray)"}}>

                        {/* TOP MENU */}
                        {/* this web does not have mobile version yet, so I added 1==2 to never show mobile version */}
                        {showMobileVersion() && 1 == 2  ?
                            {/*<TopMenuMobile searchText={this.state.searchText} setSearchText={this.setSearchText} setActualSection={this.setActualSection} topMenuExpanded={this.state.topMenuExpanded} setTopMenuExpanded={this.setTopMenuExpanded} openAlertMessage={this.openAlertMessage} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />*/}
                        :
                            <TopMenu searchText={this.state.searchText} setSearchText={this.setSearchText} setActualSection={this.setActualSection} topMenuExpanded={this.state.topMenuExpanded} setTopMenuExpanded={this.setTopMenuExpanded} openAlertMessage={this.openAlertMessage} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />
                        }

                        {/* this web does not have mobile version yet, so I added 1==2 to never show mobile version */}
                        {showMobileVersion() && 1 == 2  ?
                            <Routes>
                                {/* <Route exact path="/" element={<InstructionsMobile setActualSection={this.setActualSection} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} /> */}
                                <Route exact path="*" element={<NotFoundPage />} />
                            </Routes>
                        :
                            <Routes>
                                <Route exact path="/" element={<ListTasks searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Projects" element={<ListProjects searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Applications" element={<ListApplications searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Fundings" element={<ListFundings searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Grants" element={<ListGrants searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Submissions" element={<ListSubmissions searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/FinWorkflow" element={<ListFinWorkflow searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/ProjWorkflow" element={<ListProjWorkflow searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/NewSubmission" element={<NewSubmission searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/EditSubmission/:submissionId" element={<NewSubmission searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Submission/:submissionId" element={<SubmissionDetail searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Funding/:fundingId" element={<FundingDetail searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Application/:applicationId" element={<ApplicationDetail searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Task/:taskId" element={<TaskDetail searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Project/:projectId" element={<ProjectDetail searchText={this.state.searchText} allOrMy={this.state.allOrMy} setActualSection={this.setActualSection} leftMenuOpened={this.state.leftMenuOpened} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/FinDashboard" element={<FinDashboard setActualSection={this.setActualSection} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/FinReports" element={<FinReports setActualSection={this.setActualSection} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />

                                <Route exact path="/Testing" element={<TestingPage openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="/Rights" element={<Rights setActualSection={this.setActualSection} openAlertMessageTwoActions={this.openAlertMessageTwoActions} />} />
                                <Route exact path="*" element={<NotFoundPage />} />
                            </Routes>
                        }

                        {this.state.prepareToShowAlertModalMessage ? <AlertModalMessage showModal={this.state.showAlertModalMessage} closeModal={this.closeAlertMessage} message={this.state.alertMessage} closeButton={this.state.alertCloseButton} /> : null }
                        {this.state.prepareToShowAlertModalMessageTwoButton ? <AlertModalMessageTwoButton showModal={this.state.showAlertModalMessageTwoButton} closeModal={this.closeAlertMessage} message={this.state.alertMessage} closeButton={this.state.alertCloseButton} actionButton={this.state.alertActionButton} onActionClick={this.state.alertOnAction} /> : null }

                        {/* Alert modals for mobile devices */}
                        {this.state.prepareToShowAlertModalMessageMobile ? <AlertModalMessageMobile showModal={this.state.showAlertModalMessageMobile} closeModal={this.closeAlertModalMessageMobile} message={this.state.alertMessage} closeButton={this.state.alertCloseButton} /> : null }
                        {this.state.prepareToShowAlertModalMessageTwoButtonMobile ? <AlertModalMessageTwoButtonMobile showModal={this.state.showAlertModalMessageTwoButtonMobile} closeModal={this.closeAlertModalMessageTwoButtonMobile} message={this.state.alertMessage} closeButton={this.state.alertCloseButton} actionButton={this.state.alertActionButton} onActionClick={this.state.alertOnAction} /> : null }

                    </div>

                </div>
            </BrowserRouter>
        );
    }
}

export default App;
